import React, { useMemo, createContext, useContext } from 'react';
import { ConfigProvider } from 'antd';
import type { ThemeConfig } from 'antd';
import { createBrandTheme, lightTheme } from './index';

const CssVarContext = createContext<string>('css-var-bc-theme');

export interface BcThemeProviderProps {
  themeOverrides?: Pick<ThemeConfig, 'token' | 'components'>;
  cssVarKey?: string;
  children: React.ReactNode;
}

export const ThemeProvider = ({
  themeOverrides,
  cssVarKey = lightTheme.cssVar!.key!,
  children
}: BcThemeProviderProps) => {

  const mergedTheme = useMemo(
    () => createBrandTheme(themeOverrides, cssVarKey),
    [themeOverrides, cssVarKey]
  );

  return (
    <ConfigProvider theme={mergedTheme}>
      <CssVarContext.Provider value={cssVarKey}>
        {children}
      </CssVarContext.Provider>
    </ConfigProvider>
  );
};

export const useThemeVarsClass = () => useContext(CssVarContext);
